<div class="col m12">
    <div class="table_card_sec mb_0 mt-10">
        <div *ngIf="gridTitle!='' || showSearchOption || showExcelDownloadOption || showRecordsPerPageOption || showPagination"
            class="table_pagination_sec">
            <h4 *ngIf="gridTitle!=''" class="process_table_title">{{gridTitle}}</h4>
            <div class="p_table_main_sec">
                <ul class="ul_arrow">
                    <li *ngIf="showSearchOption">
                        <a>
                            <mat-form-field>
                                <mat-label for="search">Search</mat-label>
                                <input matInput type="text" [(ngModel)]="searchInput" (input)="onSearchChange()"
                                    id="search">
                                <button *ngIf="searchInput" matSuffix mat-icon-button aria-label="Clear"
                                    (click)="searchInput='';onSearchChange()">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <button matSuffix mat-icon-button aria-label="Search">
                                    <i class="material-icons text-secondary">search</i>
                                </button>
                            </mat-form-field>
                        </a>
                    </li>
                    <li *ngIf="showExcelDownloadOption" (click)="downloadExcel()">
                        <a>
                            <i class="material-icons text-success">file_download</i>
                        </a>
                    </li>
                    <li *ngIf="showRecordsPerPageOption" class="records-per-page">
                        <mat-form-field>
                            <!-- <mat-label>Records per page</mat-label> -->
                            <mat-select [(ngModel)]="recordsPerPage" (selectionChange)="changeRecordsPerPage()">
                                <mat-option [value]="10">10</mat-option>
                                <mat-option [value]="25">25</mat-option>
                                <mat-option [value]="50">50</mat-option>
                                <mat-option [value]="75">75</mat-option>
                                <mat-option [value]="100">100</mat-option>
                                <mat-option [value]="200">200</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </li>
                    <li *ngIf="showPagination" class="number_arrow_li_first" [class.cur-ban]="currentPage==1"
                        (click)="changePage('prev')">
                        <a><i class="material-icons">chevron_left</i></a>
                    </li>
                    <li *ngIf="showPagination" class="number_arrow_li"><a>{{currentPage}}/{{totalPages}}</a></li>
                    <li *ngIf="showPagination" class="number_arrow_li_first"
                        [class.cur-ban]="totalPages==1 || currentPage==totalPages" (click)="changePage('next')">
                        <a><i class="material-icons">chevron_right</i></a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="table scroll_table">
            <div class="btn-group1 next_prev_btn_sec">
                <a *ngIf="showScrollButton" (click)="scrollGrid('prev')" class="prev-btn btn"
                    title="chevron_left_arrow"><i class="material-icons">chevron_left</i></a>
                <a *ngIf="showScrollButton" (click)="scrollGrid('next')" class="nxt-btn btn"
                    title="chevron_right_arrow"><i class="material-icons">chevron_right</i></a>
            </div>
            <div class="outer_table">
                <div class="scrollable_other_tables">
                    <div class="tableHeaderWrp">
                    </div>
                    <div #scrollableGrid class="scroll_animation">
                        <div class="innner_scroll">
                            <div class="scroll_tables first_table">
                                <table class="other_tables">
                                    <thead>
                                        <tr>
                                            <ng-container *ngFor="let col of lstColumns;let i=index">
                                                <th *ngIf="!columnsToHide.includes(col)">
                                                    {{col}}
                                                </th>
                                            </ng-container>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let row of lstFilteredData;let rowIndex=index">
                                            <tr [class.highlight-row]="selectedRowIndex==rowIndex"
                                                *ngIf="(rowIndex >= (recordsPerPage*(currentPage-1))) && (rowIndex < (recordsPerPage*currentPage))">
                                                <ng-container *ngFor="let col of lstColumns;let colIndex=index">
                                                    <td *ngIf="!columnsToHide.includes(col)"
                                                        [ngStyle]="getCellStyle(col)"
                                                        (click)="selectedRowIndex=rowIndex;selectedColIndex=colIndex;onCellClick(col, row, rowIndex)">
                                                        <div *ngIf="row[col].type=='string'">{{ row[col].value }}</div>
                                                        <div *ngIf="row[col].type=='checkbox'">
                                                            <mat-checkbox color="primary" [(ngModel)]="row[col].value"
                                                                value="{{row[col].value}}">
                                                            </mat-checkbox>
                                                        </div>
                                                        <div *ngIf="row[col].type=='multi-select-dropdown'">
                                                            <app-dropdown-multiselect [labelText]="col"
                                                                [lstDropdownOption]="row[col].lstOption"
                                                                [selectedValues]="row[col].value"
                                                                [selectedText]="row[col].text"
                                                                [is_has_default_value]="true" [allSelected]="false"
                                                                (Raise_event_selection_changed)="multiSelect_Dropdown_change_Event($event,col, row, rowIndex)">
                                                            </app-dropdown-multiselect>
                                                        </div>
                                                    </td>
                                                </ng-container>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>